import { DateText, DisabledDate, LiveModeMarker } from '@components/common/date-picker-v2/styled';
import { featureSelector } from '@store/common/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

import { dateOptions } from './utils';

const Options = ({ selected, genChangeHandler }) => {
  const isTLBLiveEnabled = useSelector(featureSelector('vm-live-tlb'));

  const presets = dateOptions
    // map and create options for datepicker
    .map((opt) => {
      if (opt.disabled) {
        return (
          <DisabledDate key={opt.value}>
            {opt.liveMode && isTLBLiveEnabled ? <LiveModeMarker /> : ''}
            {opt.label}
          </DisabledDate>
        );
      }
      const isSelected = opt.value === selected;
      return (
        <DateText
          key={opt.value}
          className={isSelected ? 'active' : ''}
          selected={isSelected}
          onClick={genChangeHandler(opt)}
        >
          {opt.liveMode && isTLBLiveEnabled ? <LiveModeMarker /> : ''}
          {opt.label}
        </DateText>
      );
    });

  return <>{presets}</>;
};

export default Options;
